(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('InterventionDetailController', InterventionDetailController);

    InterventionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Intervention', 'AlertService','$state','Technicien', 'Principal','Point', 'ChargeTechnicien', 'DateUtils'];

    function InterventionDetailController($scope, $rootScope, $stateParams, previousState, entity, Intervention, AlertService, $state,Technicien, Principal, Point, ChargeTechnicien, DateUtils) {
        $(document).ready(function () {
            $('#field_technicien').select2();
            $('#field_technicien').on('select2:select', function (e) {
                vm.newTech = $('#field_technicien :selected').val();
            });
        });
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.bonus = {
			point:null,
			qty:1
		};
        vm.intervention = entity;
        vm.previousState = previousState.name;
        vm.manualClose = manualClose;
        vm.facturationFight = facturationFight;
        vm.removeTech = removeTech;
        vm.checkIfCanDelete = checkIfCanDelete;
        vm.removeCommentary = removeCommentary;
        vm.addBonDeCommande = addBonDeCommande;
        vm.removeBonDeCommande = removeBonDeCommande;
        vm.newTech= null;
        vm.newCharge = null;
        vm.editedTechPercentage = null;
        vm.newBonDeCommande = null;
        vm.newBonDeCommandeComment = null;
        vm.getBonDeCommandeComment = getBonDeCommandeComment;
        vm.pointsTMG = [];

        vm.addTech = addTech;
        vm.addBonus = addBonus;
        vm.addCharge = addCharge;
        vm.removeCharge = removeCharge;
        vm.removeBonus = removeBonus;
        vm.manualClose = manualClose;
        vm.removeTech = removeTech;
        vm.changeFactureForActivity = changeFactureForActivity;
        vm.changeCaTechnicienForActivity = changeCaTechnicienForActivity;
        vm.getPrixMoyenTechnicien = getPrixMoyenTechnicien;
        vm.isAdmin = false;
		vm.editDate = false;
        vm.editTechPercentage = false;
        vm.techPercentageError = false;

        vm.toggleEditTechPercentage = toggleEditTechPercentage;
        vm.saveAllPercentages = saveAllPercentages;
        vm.openCalendar = openCalendar;
		vm.saveNewDate = saveNewDate;
        vm.isInMonthRange = isInMonthRange;
        vm.isDateFuture = isDateFuture;

        Principal.identity().then(function(account) {
            if(account.authorities.indexOf("ROLE_ADMIN") === 1) {
                vm.isAdmin = true;
            }
        });

        var unsubscribe = $rootScope.$on('tmgApp:interventionUpdate', function(event, result) {
            vm.intervention = result;
        });
        $scope.$on('$destroy', unsubscribe);


        getAllDates();
        loadTechniciens();
        loadPoints();
        loadCharges();

        function isInMonthRange() {
            var d = new Date(vm.intervention.date);
            var start = new Date(vm.dateStart);
            var end = new Date(vm.dateEnd);

            start.setHours(0,0,0,0);
            end.setHours(23,59,59,999);
            d.setHours(12,0,0,0);

            return d >= start && d <= end;
        }

        function removeTech(technicien) {
            Intervention.removeTech({id: vm.intervention.id,tech: technicien},onSuccess, onError);
        }

        function removeCommentary(commentary) {
            Intervention.removeCommentary({id: vm.intervention.id,commentary: commentary},onSuccess, onError);
        }

        function addBonDeCommande() {
            Intervention.addBonDeCommande({id: vm.intervention.id, bonDeCommande: vm.newBonDeCommande, commentaire: vm.newBonDeCommandeComment}, onSuccess, onError);
        }

        function getBonDeCommandeComment(intervention, bonDeCommande) {
            if (!intervention || !intervention.listCommentary || !intervention.listCommentary.length) {
                return null;
            }
            var needle = "Bon de commande " + bonDeCommande;
            for (var i = intervention.listCommentary.length - 1; i >= 0; i--) {
                var c = intervention.listCommentary[i];
                if (c && c.indexOf(needle) !== -1) {
                    return c;
                }
            }
            return null;
        }

        function removeBonDeCommande(bonDeCommande){
            Intervention.removeBonDeCommande({id: vm.intervention.id, bonDeCommande: bonDeCommande},onSuccess, onError);
        }

        function changeFactureForActivity(activity){
            if(!vm.isSaving){
                vm.isSaving = true
                Intervention.changeActivityFacture({id: vm.intervention.id, activityCode: activity.code},onSuccess, onError);
            }
        }

        function changeCaTechnicienForActivity(activity){
            if(!vm.isSaving){
                vm.isSaving = true
                Intervention.changeActivityCaTechnicien({id: vm.intervention.id, activityCode: activity.code},onSuccess, onError);
            }
        }

        function getPrixMoyenTechnicien(activity) {
            if (!activity || !activity.point || !activity.point.averagePrice) {
                return 0;
            }
            var qty = activity.qty ? activity.qty : 1;
            return activity.point.averagePrice * qty;
        }

        function onSuccess() {
            vm.isSaving = false
            $state.go($state.current, {}, {reload: true});
        }
        function onError(error) {
            vm.isSaving = false
            AlertService.error(error.data.message);
            $state.go($state.current, {}, {reload: true});
        }

        function manualClose(id){
        	Intervention.manualClose({id:id},function(s){
        		vm.intervention.typeIntervention='MANUAL_CLOSE';
        		vm.intervention.comparaisonStatus='MANUAL_CLOSE';
        	}, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function facturationFight(id) {
            Intervention.facturationFight({id: id}, function(s){
                vm.intervention.comparaisonStatus="FACTURATION_FIGHT";
            }, function(error) {
                AlertService.error(error.data.message);
            });
        }

        function addTech() {
            if (vm.newTech !== undefined && vm.newTech !== null) {
                Intervention.addTech({id: vm.intervention.id,tech: vm.newTech},onSuccess, onError);
            }
        }

        function addBonus() {
            Intervention.addActivity({interventionId: vm.intervention.id, activityCode: vm.bonus.point, qty: vm.bonus.qty},onSuccess, onError);
        }

        function removeBonus(bonus) {
            Intervention.removeActivity({id: vm.intervention.id,code: bonus.code},onSuccess, onError);
        }

        function addCharge() {
            vm.newCharge.intervention = vm.intervention.id;
            vm.newCharge.techniciens = vm.intervention.equipes;
            var dateInter = new Date(vm.intervention.date);
            vm.newCharge.date = new Date(dateInter.getFullYear(), dateInter.getMonth() + 1, 1);
            ChargeTechnicien.save(vm.newCharge, onSuccess, onError);
        }

        function removeCharge(charge) {
            ChargeTechnicien.delete({id: charge.id}, onSuccess, onError);
        }

        function checkIfCanDelete() {
            return vm.intervention.equipes.length > 1;
        }

        function getAllDates() {
            var now = new Date();
            vm.dateStart = DateUtils.getFirstDayOfCivilMonth(now);
            vm.dateEnd = DateUtils.getLastDayOfCivilMonth(now);
        }

        function isDateFuture(date) {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var inputDate = new Date(date);
            inputDate.setHours(0, 0, 0, 0);
            return inputDate > today;
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadCharges() {
            ChargeTechnicien.getByIntervention({ interventionId: vm.intervention.id }, function onSuccess(data, headers) {
                vm.chargesTechnicien = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function loadPoints(){
            Point.categoryTMG({ }, function onSuccess(data, headers) {
                vm.pointsTMG = data;
            });
        }

        function saveAllPercentages() {
            var totalPercentage = 0;

            vm.intervention.techniciens.forEach(function(technicienIntervention) {
                totalPercentage += technicienIntervention.percentage;
            });

            if (totalPercentage !== 100) {
                vm.techPercentageError = true;
            }else {
                vm.techPercentageError = false;
                Intervention.updateTechPercentages({id: vm.intervention.id}, vm.intervention.techniciens, onSuccess, onError);
            }
        };

        function toggleEditTechPercentage() {
            vm.editTechPercentage = !vm.editTechPercentage;
        };

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

		function saveNewDate() {

            var newDate = moment(vm.intervention.date).format('YYYY-MM-DD')
			Intervention.changeDate({id: vm.intervention.id,date: newDate},onSuccess, onError);
		}

    }
})();
